import { render } from "./ShogunHeader.vue?vue&type=template&id=592e0c4a"
import script from "./ShogunHeader.vue?vue&type=script&lang=js"
export * from "./ShogunHeader.vue?vue&type=script&lang=js"

import "./ShogunHeader.vue?vue&type=style&index=0&id=592e0c4a&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__